import WHeader from './Header';

WHeader.install = (Vue) => {
  Vue.component(WHeader.name, WHeader);
};

export default WHeader;
